import { render, staticRenderFns } from "./MenuAdd.vue?vue&type=template&id=15e388d1&scoped=true&"
import script from "./MenuAdd.vue?vue&type=script&lang=js&"
export * from "./MenuAdd.vue?vue&type=script&lang=js&"
import style0 from "./MenuAdd.vue?vue&type=style&index=0&id=15e388d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e388d1",
  null
  
)

export default component.exports